(function () {
  const Core = window.RB.Core;

  const mightFloorGuard = {};
  const kwGuard = {};

  const TOKENS = {
    Recruit: { name: "Recruit", types: ["unit"], might: 1, tags: ["Recruit"], keywords: [], token: true },
    Sprite: { name: "Sprite", types: ["unit"], might: 3, tags: ["Fae"], keywords: [{ name: "Temporary", value: null }], token: true },
    "Sand Soldier": { name: "Sand Soldier", types: ["unit"], might: 2, tags: ["Shurima"], keywords: [], token: true },
    Mech: { name: "Mech", types: ["unit"], might: 3, tags: ["Mech"], keywords: [], token: true },
    Bird: { name: "Bird", types: ["unit"], might: 1, tags: ["Bird"], keywords: [{ name: "Deflect", value: 1 }], token: true },
    Tentacle: { name: "Tentacle", types: ["unit"], might: 1, tags: ["Bilgewater"], keywords: [], token: true },
    Reflection: { name: "Reflection", types: ["unit"], might: 0, tags: [], keywords: [], token: true },
    Gold: { name: "Gold", types: ["gear"], tags: [], keywords: [], token: true },
    "Shadow Clone": { name: "Shadow Clone", types: ["unit"], might: 0, tags: ["Shadow"], keywords: [], token: true },
  };

  const TOKEN_SCRIPTS = {
    Gold: {
      triggers: [],
      abilities: [{
        label: "Kill this, exhaust: Add 1 power of any domain",
        exhausts: true, killSelf: true, reaction: true, isAdd: true,
        program: [{ op: "addResources", res: { anyPower: 1 }, bonusTag: "gold" }],
      }],
    },
    "Shadow Clone": {
      triggers: [{
        on: "attack", self: true, optional: true,
        label: "banish a trash unit for Assault 4",
        targets: [{ bind: "t", spec: { type: "unit", zone: "trash" }, prompt: "Banish which unit from your trash?" }],
        program: [{ op: "banish", to: "$t" }, { op: "grant", to: "source", keyword: "assault", kwValue: 4, dur: "turn" }],
      }],
      abilities: [],
    },
  };

  function cloneValue(v) {
    if (Array.isArray(v)) return v.map(cloneValue);
    if (v && typeof v === "object") {
      const out = {};
      for (const k in v) out[k] = cloneValue(v[k]);
      return out;
    }
    return v;
  }

  const SCRIPTS = window.RB.CardScripts;

  const cache = {};
  let subscribed = null;

  function compileProgram(prog) {
    if (!prog) return prog;
    const out = [];
    for (const op of prog) {
      if (op.op === "if" && (op.then || op.else)) {
        const thenOps = compileProgram(op.then || []);
        const elseOps = compileProgram(op.else || []);
        const flat = { op: "if", cond: op.cond, skip: thenOps.length + (elseOps.length ? 1 : 0) };
        out.push(flat);
        for (const o of thenOps) out.push(o);
        if (elseOps.length) {
          out.push({ op: "jump", n: elseOps.length });
          for (const o of elseOps) out.push(o);
        }
        continue;
      }
      if (op.op === "may" && op.then) {
        const thenOps = compileProgram(op.then);
        out.push({ op: "may", prompt: op.prompt, skip: thenOps.length });
        for (const o of thenOps) out.push(o);
        continue;
      }
      if (op.program || op.modes) {
        const copy = {};
        for (const k in op) copy[k] = op[k];
        if (op.program) copy.program = compileProgram(op.program);
        if (op.modes) {
          copy.modes = op.modes.map(function (m) {
            const mc = {};
            for (const k in m) mc[k] = m[k];
            if (m.then) mc.then = compileProgram(m.then);
            return mc;
          });
        }
        out.push(copy);
        continue;
      }
      out.push(op);
    }
    return out;
  }

  function walkOps(prog, fn) {
    for (const op of prog || []) {
      fn(op);
      walkOps(op.then, fn);
      walkOps(op.else, fn);
      walkOps(op.program, fn);
    }
  }

  function lintScript(script, name) {
    const bad = function (msg) { throw new Error("card script " + name + ": " + msg); };
    const trigLists = [script.triggers, script.attachedTriggers, script.trashTriggers];
    for (const slot of programSlots(script)) {
      const prog = slot[0][slot[1]];
      walkOps(prog, function (op) {
        if (!op || typeof op.op !== "string") bad("malformed op " + JSON.stringify(op));
        if (!RB.FX.OPS[op.op]) bad("unknown op '" + op.op + "'");
        if (op.op === "delayed" && !RB.FX.EVENTS[op.on]) bad("delayed effect on unknown event '" + op.on + "'");
        if (op.op === "reEmit" && !RB.FX.EVENTS[op.event]) bad("reEmit of unknown event '" + op.event + "'");
        if (op.cond && typeof op.cond !== "function" && !RB.FX.COND_KEYS[op.cond.k]) bad("unknown condition '" + op.cond.k + "'");
      });
    }
    for (const list of trigLists) {
      for (const t of list || []) {
        if (!RB.FX.EVENTS[t.on]) bad("trigger on unknown event '" + t.on + "'");
        if (t.condSpec && !RB.FX.COND_KEYS[t.condSpec.k] ) bad("unknown trigger condition '" + t.condSpec.k + "'");
      }
    }
    for (const k in script.attachedEventAlias || {}) {
      if (!RB.FX.EVENTS[script.attachedEventAlias[k]]) bad("alias to unknown event '" + script.attachedEventAlias[k] + "'");
    }
    walkConds(script, bad);
  }

  const COND_KEY_NAMES = { cond: 1, condSpec: 1, targetCond: 1 };
  const COND_EXEMPT = { notInCombat: 1 };

  function checkCond(c, bad) {
    if (!c || typeof c === "function") return;
    if (typeof c !== "object") return;
    if (typeof c.k === "string" && !RB.FX.COND_KEYS[c.k] && !COND_EXEMPT[c.k]) bad("unknown condition '" + c.k + "'");
    for (const sub of c.conds || []) checkCond(sub, bad);
    if (c.cond) checkCond(c.cond, bad);
  }

  function walkConds(x, bad, seen) {
    if (!x || typeof x !== "object") return;
    seen = seen || [];
    if (seen.indexOf(x) >= 0) return;
    seen.push(x);
    if (Array.isArray(x)) {
      for (const v of x) walkConds(v, bad, seen);
      return;
    }
    for (const key in x) {
      const v = x[key];
      if (COND_KEY_NAMES[key]) checkCond(v, bad);
      walkConds(v, bad, seen);
    }
  }

  function programSlots(script) {
    const slots = [[script, "play"], [script, "deathknell"], [script, "attachedDeathknell"]];
    if (script.onAttach) slots.push([script.onAttach, "program"]);
    for (const list of [script.triggers, script.attachedTriggers, script.trashTriggers, script.abilities, script.legendAbilities]) {
      for (const t of list || []) slots.push([t, "program"]);
    }
    for (const ac of script.addCosts || []) { slots.push([ac, "then"]); slots.push([ac, "otherwise"]); }
    if (script.banishedWithPayoff) slots.push([script.banishedWithPayoff, "program"]);
    for (const rt of script.revealTriggers || []) slots.push([rt, "program"]);
    for (const g of script.auraAbilities || []) if (g.ability) slots.push([g.ability, "program"]);
    return slots;
  }

  function compileScript(script, name) {
    lintScript(script, name);
    for (const slot of programSlots(script)) {
      if (slot[0][slot[1]]) slot[0][slot[1]] = compileProgram(slot[0][slot[1]]);
    }
    return script;
  }

  function auraMatch(state, r, src, so, iid, o, opt) {
    opt = opt || {};
    const p = opt.p !== undefined ? opt.p : o.controller;
    const loc = opt.loc !== undefined ? opt.loc : (o && o.loc);
    const who = r.who === "enemyUnits" ? "enemy" : r.who === "friendlyUnits" ? "friendly" : (r.who || opt.whoDefault || "friendly");
    if (who === "friendly" && so.controller !== p) return false;
    if (who === "enemy" && so.controller === p) return false;
    if (r.requiresControl && so.controller !== p) return false;
    if (r.whileAtBf && !(so.loc && so.loc.t === "bf")) return false;
    const what = r.what || {};
    if (what.type && !Core.isType(state, iid, what.type)) return false;
    if (what.tag && !Core.hasTag(state, iid, what.tag)) return false;
    if (what.hasKw && !Core.hasKw(state, iid, what.hasKw)) return false;
    if (r.scope === "here" && !(so.loc && loc && Core.sameLoc(so.loc, loc))) return false;
    if (r.scope === "hereBf" && !(so.loc && so.loc.t === "bf" && loc && Core.sameLoc(so.loc, loc))) return false;
    if (r.scope === "atSource" && !(loc && loc.t === "bf" && loc.iid === src)) return false;
    if (r.cond && !Scripts.staticCond(state, src, opt.condFor === "affected" ? p : so.controller, r.cond)) return false;
    return true;
  }

  function auraApplies(state, sp, s, so, iid, o) {
    if (sp.excludeSelf && s === iid) return false;
    if (!auraMatch(state, sp, s, so, iid, o, { whoDefault: sp.who === "all" ? "all" : "friendly" })) return false;
    if (sp.targetCond && !Scripts.staticCond(state, iid, o.controller, sp.targetCond)) return false;
    return true;
  }

  const Scripts = {
    compileProgram: compileProgram,
    lintScript: lintScript,

    tokenDef(name) {
      return TOKENS[name] || null;
    },

    staticKeywords(state, iid) {
      const o = state.objs[iid];
      if (!o || (o.zone !== "board" && o.zone !== "chain" && o.zone !== "hand")) return [];
      if (kwGuard[iid]) return [];
      kwGuard[iid] = 1;
      try {
        return Scripts.staticKeywordsInner(state, iid, o);
      } finally {
        delete kwGuard[iid];
      }
    },

    staticKeywordsInner(state, iid, o) {
      if (o.zone === "chain" || o.zone === "hand") {
        const out2 = [];
        for (const s2 of Core.boardObjs(state)) {
          const so2 = state.objs[s2];
          if (!so2 || so2.attachedTo) continue;
          const sc2 = Scripts.forCard(state, s2);
          for (const sp of (sc2 && sc2.auraPlayKwSpecs) || []) {
            if (o.zone === "hand" && !sp.inHand) continue;
            if (o.zone !== "hand" && sp.inHand && !sp.onChain) continue;
            const kwOwner = o.zone === "hand" ? o.owner : o.controller;
            if (sp.who === "enemy" ? so2.controller === kwOwner : so2.controller !== kwOwner) continue;
            if (sp.what && sp.what.type && !Core.isType(state, iid, sp.what.type)) continue;
            if (sp.what && sp.what.tag && !Core.hasTag(state, iid, sp.what.tag)) continue;
            if (sp.fromZone === "notHand" && (o.playFromZone || "hand") === "hand") continue;
            if (sp.cond && !Scripts.staticCond(state, s2, so2.controller, sp.cond)) continue;
            out2.push([sp.name, sp.value]);
          }
        }
        return out2;
      }
      const out = [];
      const self = Scripts.forCard(state, iid);
      if (self && self.selfKw) {
        for (const kw of self.selfKw(state, iid) || []) out.push(kw);
      }
      if (self && self.selfKwSpecs) {
        for (const sp of self.selfKwSpecs) {
          if (Scripts.staticCond(state, iid, o.controller, sp.cond)) out.push([sp.name, sp.value]);
        }
      }
      for (const aIid of o.attachments || []) {
        const asc = Scripts.forCard(state, aIid);
        if (!asc) continue;
        for (const kw of asc.attachedKw || []) out.push(kw);
        for (const sp of asc.attachedKwSpecs || []) {
          if (Scripts.staticCond(state, iid, o.controller, sp.cond, aIid)) out.push([sp.name, sp.value]);
        }
        if (asc.attachedCopyHost && self) {
          if (self.selfKw) for (const kw of self.selfKw(state, iid) || []) out.push(kw);
          for (const sp of self.selfKwSpecs || []) {
            if (Scripts.staticCond(state, iid, o.controller, sp.cond)) out.push([sp.name, sp.value]);
          }
        }
      }
      const srcs = Core.effectSources(state, { battlefields: false });
      for (const s2 of srcs) {
        const so = state.objs[s2];
        if (!so || so.attachedTo) continue;
        const sc = Scripts.forCard(state, s2);
        if (s2 !== iid && sc && sc.auraKw) {
          for (const kw of sc.auraKw(state, s2, iid) || []) out.push(kw);
        }
        if (sc && sc.auraKwSpecs && Core.isType(state, iid, "unit")) {
          for (const sp of sc.auraKwSpecs) {
            if (auraApplies(state, sp, s2, so, iid, o)) out.push([sp.name, sp.value]);
          }
        }
        for (const aIid of so.attachments || []) {
          const asc2 = Scripts.forCard(state, aIid);
          if (!asc2 || !asc2.attachedAuraKw) continue;
          for (const ak of asc2.attachedAuraKw) {
            if (ak.scope === "here" && (!Core.isType(state, iid, "unit") || so.controller !== o.controller || !Core.sameLoc(so.loc, o.loc))) continue;
            out.push([ak.name, ak.value]);
          }
        }
      }
      return out;
    },

    staticCond(state, iid, p, cond, via) {
      return RB.FX.evalCond(state, cond, { iid: iid, p: p, via: via });
    },

    trigCond(state, iid, ev, cond) {
      const o = state.objs[iid];
      return RB.FX.evalCond(state, cond, { iid: iid, ev: ev, p: o ? o.controller : 0 });
    },

    staticMight(state, iid) {
      const o = state.objs[iid];
      if (!o || o.zone !== "board") return 0;
      let m = 0;
      const self = Scripts.forCard(state, iid);
      if (self && self.selfMight) m += self.selfMight(state, iid) || 0;
      if (self && self.selfMightSpecs) {
        for (const sp of self.selfMightSpecs) {
          if (Scripts.staticCond(state, iid, o.controller, sp.cond)) m += sp.n;
        }
      }
      for (const aIid of o.attachments || []) {
        const asc = Scripts.forCard(state, aIid);
        if (!asc) continue;
        for (const sp of asc.attachedMightSpecs || []) {
          if (Scripts.staticCond(state, iid, o.controller, sp.cond, aIid)) m += sp.n;
        }
        if (asc.attachedCopyHost && self) {
          if (self.selfMight) m += self.selfMight(state, iid) || 0;
          for (const sp of self.selfMightSpecs || []) {
            if (Scripts.staticCond(state, iid, o.controller, sp.cond)) m += sp.n;
          }
        }
      }
      const srcs = Core.effectSources(state, { battlefields: false });
      for (const s of srcs) {
        const so = state.objs[s];
        if (!so || so.attachedTo) continue;
        const sc = Scripts.forCard(state, s);
        if (s !== iid && sc && sc.auraMight) m += sc.auraMight(state, s, iid) || 0;
        if (sc && sc.auraMightSpecs && Core.isType(state, iid, "unit")) {
          for (const sp of sc.auraMightSpecs) {
            if (!auraApplies(state, sp, s, so, iid, o)) continue;
            if (sp.floor === undefined) {
              m += sp.n;
            } else if (!mightFloorGuard[iid]) {
              mightFloorGuard[iid] = 1;
              try {
                m += RB.FX.flooredMight(state, iid, { might: sp.n, floor: sp.floor });
              } finally {
                delete mightFloorGuard[iid];
              }
            }
          }
        }
      }
      return m;
    },

    grantedAbilities(state, iid) {
      const o = state.objs[iid];
      if (!o) return [];
      const out = [];
      const srcs = Core.effectSources(state, { legends: false });
      for (const s of srcs) {
        const so = state.objs[s];
        if (!so || so.attachedTo || s === iid) continue;
        const sc = Scripts.forCard(state, s);
        for (const g of (sc && sc.auraAbilities) || []) {
          if (!auraMatch(state, g, s, so, iid, o)) continue;
          if ((g.what || {}).legend ? o.zone !== "legendZone" : o.zone !== "board") continue;
          out.push(Object.assign({}, g.ability, { grantedBy: s }));
        }
      }
      return out;
    },

    abilitiesOf(state, iid) {
      const own = Scripts.forCard(state, iid);
      const o = state.objs[iid];
      let list = (own && own.abilities) || [];
      if (own && own.legendAbilities && o && o.zone === "legendZone") list = list.concat(own.legendAbilities);
      const granted = Scripts.grantedAbilities(state, iid);
      if (granted.length) list = list.concat(granted);
      for (const g of (o && o.grants) || []) {
        if (g.k === "ability" && g.ability) list = list.concat([g.ability]);
      }
      if (!own || !own.inheritExhaustAbilities) return list;
      const out = list.slice();
      const srcs = Core.boardObjs(state).concat([state.players[o.controller].legendIid]);
      for (const s of srcs) {
        const so = state.objs[s];
        if (!so || s === iid || so.controller !== o.controller || so.attachedTo) continue;
        const sc = Scripts.forCard(state, s);
        for (const ab of (sc && sc.abilities) || []) {
          if (!ab.exhausts) continue;
          out.push(Object.assign({}, ab, { inheritedFrom: s }));
        }
      }
      return out;
    },

    dealBonusInfo(state, item, t) {
      const out = { n: 0, from: [] };
      if (!state.objs[t]) return out;
      for (const m of (item && item.playMods) || []) {
        out.n += m.n;
        out.from.push({ iid: m.source, name: m.source ? Core.name(state, m.source) : "effect", n: m.n });
      }
      for (const s of Core.boardObjs(state)) {
        const so = state.objs[s];
        if (so.attachedTo) continue;
        const sc = Scripts.forCard(state, s);
        if (sc && sc.bonusDamage) {
          const b = sc.bonusDamage(state, s, item, t) || 0;
          if (b) {
            out.n += b;
            out.from.push({ iid: s, name: Core.name(state, s), n: b });
          }
        }
        for (const aIid of so.attachments || []) {
          const asc = Scripts.forCard(state, aIid);
          if (!asc || !asc.attachedBonusDamage || so.controller !== item.controller) continue;
          out.n += asc.attachedBonusDamage;
          out.from.push({ iid: aIid, name: Core.name(state, aIid), n: asc.attachedBonusDamage });
        }
      }
      return out;
    },

    auraMatch: auraMatch,

    anySource(state, key, opts) {
      const o = opts || {};
      return Core.boardObjs(state).some(function (iid) {
        const so = state.objs[iid];
        if (so.attachedTo) return false;
        if (o.controller !== undefined && so.controller !== o.controller) return false;
        if (o.atBf && !(so.loc && so.loc.t === "bf" && (o.atBf === true || so.loc.iid === o.atBf))) return false;
        const sc = Scripts.forCard(state, iid);
        if (!sc || !sc[key]) return false;
        return !o.test || o.test(sc[key]);
      });
    },

    forCard(state, iid) {
      const c = Core.card(state, iid);
      return c ? Scripts.forCardDef(c) : null;
    },

    forCardDef(c) {
      if (c.token) return TOKEN_SCRIPTS[c.name] || { triggers: [], abilities: [] };
      const key = c.id || c.name;
      if (cache[key]) return cache[key];
      const script = compileScript(Scripts.build(c), c.name);
      cache[key] = script;
      return script;
    },

    subscribedEvents() {
      if (subscribed) return subscribed;
      subscribed = {};
      const note = function (script) {
        if (!script) return;
        for (const list of [script.triggers, script.attachedTriggers, script.trashTriggers]) {
          for (const t of list || []) subscribed[t.on] = true;
        }
        for (const k in script.attachedEventAlias || {}) subscribed[script.attachedEventAlias[k]] = true;
      };
      for (const c of window.CARD_DB) note(Scripts.forCardDef(c));
      for (const name in TOKEN_SCRIPTS) note(TOKEN_SCRIPTS[name]);
      return subscribed;
    },

    build(c) {
      const script = {
        play: null, targets: [], triggers: [], abilities: [],
        deathknell: null, deathknellTargets: [],
        costMod: null, unscripted: false, legendAdd: null,
      };
      script.rulesLines = (c.manual || []).slice();
      const entry = SCRIPTS[c.name];
      if (entry) {
        for (const k in entry) script[k] = cloneValue(entry[k]);
        script.unscripted = !!entry.manualLines;
        return script;
      }
      if (script.rulesLines.length) {
        script.unscripted = true;
        script.manualLines = script.rulesLines.slice();
      }
      return script;
    },

    legendAdd(state, iid) {
      const script = Scripts.forCard(state, iid);
      if (!script || !script.legendAdd) return null;
      const res = script.legendAdd;
      if (res.requires === "legion") {
        const p = state.objs[iid].controller;
        if (state.turnFacts.players[p].played < 1) return null;
      }
      return res;
    },

    _scripts: SCRIPTS,
  };

  window.RB.Scripts = Scripts;
})();
